// How this works...

/*
  - BCSfFilterCallback
  - BCSfFilter.afterGetFilterData
  - BCSfFilter.buildAll
  - BCSfFilter.buildProductList
  - BCSfFilter.buildProductListData
  - BCSfFilter.buildProductGridItem
*/

BCSfFilter.prototype.buildProductListData = (products, eventType) => {
  if (eventType === 'history') {
    return
  }

  $(window).trigger($.Event('bcsfFilter.buildProductListData', { products, eventType }));
}

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
// Prevent taxi from picking up clicks on filter links
  $('a.bc-sf-filter-option-item').attr('data-taxi-ignore', true)
}